import React from "react";
import TopicList from "../../TotLife/TopicList";
import ArticleSummaryRows from "../../TotLife/ArticleSummary-Rows";
import * as styles from './layoutTotLife.module.scss';
import SubpageHeaderBar from "../../subpageHeaderBar/SubpageHeaderBar";


const LayoutTotLife: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {

    return (
        <div className={styles.layoutTotLife}>
            <SubpageHeaderBar
            header1="Tot-Life"
            header2="A Welltot Magazine"
            className={styles.totLifeHeader}
            />
            <div className={styles.totLifeTopics}>
                <TopicList topicId={props.topicId} />
            </div>
            <div className={styles.totLifeArticleSummaries}>
                {props.articleSummaries.map(({ node }) => (
                    <ArticleSummaryRows key={node.id} node={node} />
                ))}
            </div>
        </div>
    );
};


export default LayoutTotLife;